import React from 'react';
import './cardTwo.css';
import image from '../../assets/tutors-icon.svg'

function CardTwo({text, heading}) {
    return (
        <div className="cardTwo__main">
            <div className="cardTwo__img">
                <img src={image} alt="" />
            </div>
            <div className="cardTwo__heading">
                <div className="head__three">
                    {heading}
                </div>
            </div>
            <div className="cardTwo__text">
           {text}
            </div>
        </div>
    )
}

export default CardTwo
